import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

import Icon from 'Pods/Shared/Icon/Icon'
import ShareModal from 'Pods/Shared/ShareModal'
import ContactModal from 'Pods/Shared/ContactModal'

import OfferPriceModal from './Components/OfferPriceModal'
import ReportModal from './Components/ReportModal'

const actionsMap = {
  openContactModal: 'contactModalIsOpen',
  openOfferPriceModal: 'offerPriceModalIsOpen',
  openReportModal: 'openReportModal',
  openShareModal: 'shareModalIsOpen',
}

class ProductActionButton extends React.Component {
  constructor() {
    super()

    this.state = {
      contactModalIsOpen: false,
      offerPriceModalIsOpen: false,
      openReportModal: false,
      showButtonMenu: false,
      shareModalIsOpen: false,
      messagingForbidden: false,
    }

    this.buttonMenuRef = React.createRef()

    this.toggleButtonMenu = this.toggleButtonMenu.bind(this)
    this.handleClickOutside = this.handleClickOutside.bind(this)
  }

  componentDidMount() {
    this.props.action === 'openReportModal' && document.addEventListener('mousedown', this.handleClickOutside)

    this.setState({ messagingForbidden: App.config.messagingForbidden })
  }

  componentWillUnmount() {
    this.props.action === 'openReportModal' && document.removeEventListener('mousedown', this.handleClickOutside)
  }

  handleClickOutside(e) {
    if (this.buttonMenuRef.current && !this.buttonMenuRef.current.contains(e.target) && this.state.showButtonMenu) {
      this.setState({ showButtonMenu: false })
    }
  }

  performAction(e, action) {
    e.preventDefault()

    if (this.props.isSignedIn) {
      this.setState({ [actionsMap[action]]: true })
    } else {
      App.events.publish('app:login:open')
    }
  }

  closeModal(e, modalState) {
    if (e) e.preventDefault()
    this.setState({ [modalState]: false })
  }

  toggleButtonMenu() {
    this.setState({ showButtonMenu: !this.state.showButtonMenu })
  }

  render() {
    return (
      <Fragment>
        {this.props.isButton ? (
          this.props.action === 'openReportModal' ? (
            <div className="product-button" ref={this.buttonMenuRef}>
              <button type="button" className={this.props.classes} onClick={this.toggleButtonMenu}>
                <Icon type={this.props.iconType} notSpaced />
              </button>

              {this.state.showButtonMenu && (
                <div className="card product-button__dropdown">
                  <button type="button" className="btn btn-transparent" onClick={(e) => this.performAction(e, this.props.action)}>
                    <Icon type={['far', 'exclamation-triangle']} /> Report this item
                  </button>
                </div>
              )}
            </div>
          ) : (
            <button type="button" className={this.props.classes} onClick={(e) => this.performAction(e, this.props.action)}>
              {this.props.iconType ? <Icon type={this.props.iconType} notSpaced /> : ''} {this.props.title}
            </button>
          )
        ) : (
          <span className="modal-link" onClick={(e) => this.performAction(e, this.props.action)}>{this.props.title}</span>
        )}

        {this.state.contactModalIsOpen && (
          <ContactModal
            modalIsOpen
            closeModal={(e) => this.closeModal(e, 'contactModalIsOpen')}
            itemId={this.props.itemId}
            authorUsername={this.props.authorUsername}
            conversationType="model_support"
            messagingForbidden={this.state.messagingForbidden}
          />
        )}

        {this.state.offerPriceModalIsOpen && (
          <OfferPriceModal
            modalIsOpen
            closeModal={(e) => this.closeModal(e, 'offerPriceModalIsOpen')}
            itemPrice={this.props.itemPrice}
            itemId={this.props.itemId}
          />
        )}

        {this.state.openReportModal && (
          <ReportModal
            modalIsOpen
            closeModal={(e) => this.closeModal(e, 'openReportModal')}
            itemId={this.props.itemId}
            options={this.props.options}
          />
        )}

        {this.state.shareModalIsOpen && (
          <ShareModal
            closeModal={(e) => this.closeModal(e, 'shareModalIsOpen')}
            url={window.location.href}
            socialTitle="Share model on"
            socialNetworks={['facebook', 'twitter', 'pinterest', 'linkedin']}
            showSocial
            showDirectCopyUrl
          />
        )}
      </Fragment>
    )
  }
}

ProductActionButton.propTypes = {
  classes: PropTypes.string.isRequired,
  action: PropTypes.string.isRequired,
  isSignedIn: PropTypes.bool.isRequired,
  title: PropTypes.string,
  iconType: PropTypes.array,
  itemId: PropTypes.string.isRequired,
  authorUsername: PropTypes.string,
  isButton: PropTypes.bool,
  options: PropTypes.array,
}

ProductActionButton.defaultProps = {
  title: '',
  iconType: null,
  authorUsername: '',
  isButton: true,
}

export default ProductActionButton
